// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".phone-wrapper[data-v-5bc5d509]{margin:0 auto;max-width:700px;padding:16px}.icon-warning[data-v-5bc5d509]{color:var(--v-warning-base)!important;margin-bottom:2px;margin-right:5px}.warning-title[data-v-5bc5d509]{margin-bottom:10px}.warning-container-wrapper[data-v-5bc5d509]{margin-top:60px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
